import { render } from "./CreateMedicationClassDialog.vue?vue&type=template&id=b2e2a97e"
import script from "./CreateMedicationClassDialog.vue?vue&type=script&lang=js"
export * from "./CreateMedicationClassDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__